module.exports = {
    langs: ['ru', 'en'],
    defaultLangKey: 'en'
  };